/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { Redirect } from "react-router-dom";
// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { Badge } from "reactstrap";

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const [dataId, setDataId] = useState("");
  const [option1, setOption1] = useState("");
  const [option2, setOption2] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const classes = useStyles();
  const { tableHead, tableData, tableHeaderColor } = props;

  const test = e => {
    if (e !== null) {
      setDataId(e[8]);
      setOption1(e[9]);
      setOption2(e[10]);
      if (e[11] !== null && e[11] !== undefined) {
        if (typeof e[11] !== "string") {
          setOption3(e[11]);
        } else {
          setOption3(0);
        }
      } else {
        setOption3(0);
      }
      if (e[12] !== null && e[12] !== undefined) {
        if (typeof e[12] !== "string") {
          setOption4(e[12]);
        } else {
          setOption4(0);
        }
      } else {
        setOption4(0);
      }
    }
  };

  function tags(e) {
    return e[e.length - 1];
  }

  const test2 = () => {
    if (
      dataId !== "" &&
      option1 !== "" &&
      option2 !== "" &&
      option3 !== "" &&
      option4 !== ""
    ) {
      return (
        <Redirect
          from="/"
          to={
            "/admin/dashboard?dataId=" +
            dataId +
            "&option1=" +
            option1 +
            "&option2=" +
            option2 +
            "&option3=" +
            option3 +
            "&option4=" +
            option4
          }
        />
      );
    }
  };

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.slice().map((prop, key1) => {
            return (
              <TableRow
                key={key1}
                className={classes.tableBodyRow}
                style={{ cursor: "pointer" }}
                selected={true}
                hover={true}
                onClick={() => test(prop)}
              >
                {tableData[key1][8] !== undefined
                  ? prop.slice(0, 8).map((prop, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <h6>
                            {prop}
                            {"   "}
                            {key === 0 ? (
                              <Badge color="secondary">
                                {tags(tableData[key1])}
                              </Badge>
                            ) : (
                              ""
                            )}
                          </h6>
                          {test2()}
                        </TableCell>
                      );
                    })
                  : prop.slice(0, 1).map((prop, key) => {
                      return (
                        <TableCell className={classes.tableCell} key={key}>
                          <h6>{prop}</h6>
                        </TableCell>
                      );
                    })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
